/**
 * API配置文件
 * 预留环境切换，支持本地开发和生产部署
 */
// 是否使用本地模拟数据
export const USE_MOCK = false;
// API基础URL配置
// 兼容构建环境变量异常时的运行时路径判断
const isProdRuntime = process.env.NODE_ENV === 'production' ||
    (typeof window !== 'undefined' && window.location.pathname.startsWith('/blog/'));
export const BASE_API_URL = isProdRuntime
    ? '/api' // 生产环境通过反向代理
    : '/blog-dev/api'; // 开发调试通过Nginx代理到8081端口
// 超时时间配置（毫秒）
export const REQUEST_TIMEOUT = 10000;
